// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1edOm","label":"CategoryService_label__1_ukd","location":"CategoryService_location__2PBqK"};